module.exports = __webpack_public_path__ + "static/media/login-cpa-video.208eba2d.mp4";